module.exports = __webpack_public_path__ + "img/41-green.71bc2a35.svg";